import styled from 'styled-components';

export const ListRoot = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
`;

export const NodeRow = styled.div<{ $level: number }>`
  display: flex;
  align-items: center;
  padding-left: ${({ $level }) => $level * 16}px;
`;

export const ChildrenBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
